export const ornateParticipationFrame = () => ({
  id: 'ornate-participation-frame',
  name: 'Ornate Participation Frame',
  thumbnail: '/assets/diploma-templates/04_frame.webp',
  data: {
    elements: [],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/04_background.svg',
      key: null
    }
  }
});
